// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channels-page {
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/ChannelsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".channels-page {\n  display: flex;\n  position: relative;\n  height: 100%;\n  width: 100%;\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
